const SIDEBAR_OPEN_CLASS = 'is-open';
const BODY_LOCK_CLASS = 'hotsite-mobile-sidebar-open';

const getSidebar = () => document.getElementById('hotsite-mobile-sidebar');

const getToggleButtons = () => document.querySelectorAll('[data-hotsite-sidebar-toggle]');

const setSidebarOpen = (isOpen) => {
  const sidebar = getSidebar();
  if (!sidebar) return;

  sidebar.classList.toggle(SIDEBAR_OPEN_CLASS, isOpen);
  sidebar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  document.body.classList.toggle(BODY_LOCK_CLASS, isOpen);

  getToggleButtons().forEach((button) => {
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
};

const openSidebar = () => setSidebarOpen(true);
const closeSidebar = () => setSidebarOpen(false);

let listenersBound = false;

const bindSidebarListeners = () => {
  if (listenersBound) return;

  listenersBound = true;

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-hotsite-sidebar-toggle]')) {
      event.preventDefault();
      openSidebar();
      return;
    }

    if (event.target.closest('[data-hotsite-sidebar-close]')) {
      event.preventDefault();
      closeSidebar();
      return;
    }

    if (event.target.closest('.hotsite-mobile-sidebar__link')) {
      closeSidebar();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSidebar();
  });
};

const initMobileSidebar = () => {
  bindSidebarListeners();
  closeSidebar();
};

document.addEventListener('turbolinks:load', initMobileSidebar);
document.addEventListener('DOMContentLoaded', initMobileSidebar);
